import React, { useState, useEffect} from 'react';
import { Link, useParams} from 'react-router-dom';
import { useSelector,useDispatch} from "react-redux";
import { api } from '../../api';
import { toast } from "react-toastify";
import { setSwitchRegion  } from "../../redux/authSlice";

const ViewMasterProduct = props => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const { userType: role } = useSelector((state) => state.auth.user);

    const {id} = useParams(); // Rename 'id' to 'merchentId'
    const [master, setMaster] = useState({})

    useEffect(() => {
    dispatch(setSwitchRegion(false));

    return () => {
        dispatch(setSwitchRegion(true)); // reset when unmounting
    };
    }, [dispatch]);

    useEffect(() => {
        api.products.getMasterProductById({ masterProductId: id },token)
            .then(res => {
                if (res.success === false) {
                    toast.error(res.message);
                }
                setMaster(res.data)
            }).catch(err => {
                toast.error("Something went wrong");
            })
    }, [token,id])

    return (

        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="box-row">
                        <div className="table-head">
                            <h1 className="sec-header">VIEW MASTER PRODUCT</h1>
                        </div>
                        <div className="card">
                            <div className="card-body box-row">

                                {/* <h1 className="section-header float-left">Master Product Details</h1> */}

                                {role !== 3 && role !== 4 &&
                                    <div style={{ position: 'absolute', top: '0px', right: '15px' }}>
                                        <Link to={`/edit-master/${id}`}>
                                            <button className="btn mt-3 submit-btn" variant="primary" type="submit"> Edit </button>
                                        </Link>
                                    </div>
                                }
                                <div style={{ margin: '0px 50px' }}>
                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Master Product name</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{master.masterProductName}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Brand ID</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{master.brandId}</span></div>
                                    </div>

                                    {
                                        master.refId !== ""  &&
                                            <div className="form-group row col-md-12">
                                                <div className="col-md-3"><span><b>Ref ID</b>{' '}:</span></div>
                                                <div className="col-md-8"><span>{master.refId}</span></div>
                                            </div>
                                    }

                                    {
                                        master.refProductId !== ""  &&
                                            <div className="form-group row col-md-12">
                                                <div className="col-md-3"><span><b>Refernece Product ID</b>{' '}:</span></div>
                                                <div className="col-md-8"><span>{master.refProductId}</span></div>
                                            </div>
                                    }

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>price</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{master.price}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Margin</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{master.margin}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Denomination</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{master.denomination}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Threshold Value</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{master.thresholdValue}</span></div>
                                    </div>

                                    <div className="form-group row col-md-12">
                                        <div className="col-md-3"><span><b>Stock Available</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{master.stockAvailable}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    );
}

export default ViewMasterProduct;